import React from 'react';
import './intro.css';
import EvaPulsatingHead from './EvaPulsatingHead.jsx';

/**
 * Eva’s talking‑head component.
 * Displays Eva's avatar and a message.
 */
const EvaAvatar = ({ message, audioVolume = 0 }) => {
  return (
    <div className="eva-avatar">
      <EvaPulsatingHead audioVolume={audioVolume} />
    </div>
  );
};

export default EvaAvatar;